









































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import {Tag} from "@/models/tag";

@Component({
  components: {}
})
export default class SearchFiltersInfo extends Vue {
  @Prop({default: []}) private value!: Array<any>;
  @Prop({default: []}) private filtersCallBack!: Array<any>;
  @Prop({default: "0"}) private totalResults!: String;
  @Prop({default: true}) private showTags!: boolean;
  @Prop({default: true}) private showCount!: boolean;

  showMap: boolean = false;

  @Emit('showMapChange')
  showMapChange() {
    return this.showMap;
  }

  showMapClicked() {
    this.showMap = !this.showMap;
    this.showMapChange();
  }

  get tags() {
    let allTags = [];
    for (let i = 0; i < this.value.length; i++) {
      const value = this.value[i];
      if ('selectedVal' in value && value.selectedVal.length > 0)
        if (value.type === 'inputDate') {
            if (value.selectedVal.length < 1) continue;
            if (value.selectedVal.length > 1) {
                const date0 = new Date(Date.parse(`${value.selectedVal[0]}T00:00:00`)),
                      date1 = new Date(Date.parse(`${value.selectedVal[1]}T00:00:00`)),
                      dateStartValues = { day: ('00' + (date0.getDate())).slice(-2), month: ('00' + (date0.getMonth() + 1)).slice(-2), year: date0.getFullYear() },
                      dateEndValues = { day: ('00' + (date1.getDate())).slice(-2), month: ('00' + (date1.getMonth() + 1)).slice(-2), year: date1.getFullYear() },
                      dateStart = this.$t('general.dateStart', dateStartValues),
                      dateEnd = this.$t('general.dateEnd', dateEndValues);

                allTags.push({ name: dateStart, filterID: i, id: dateStart });
                allTags.push({ name: dateEnd, filterID: i, id: dateEnd });
            } else {
                const date = new Date(Date.parse(`${value.selectedVal[0]}T00:00:00`)),
                      day = ('00' + (date.getDate())).slice(-2), month = ('00' + (date.getMonth() + 1)).slice(-2), year = date.getFullYear(),
                      strDate = this.$t('general.date', { day, month, year });
                allTags.push({ name: strDate, filterID: i, id: value.id })
            }
        } else {
            for (let k = 0; k < value.selectedVal.length; k++) {
                allTags.push({ ...value.selectedVal[k], filterID: i });
            }
        }
    }
    return allTags;
  }

  removeTag(filterID: number, tagID: string) {
    const filterSelectedValues = this.value[filterID].selectedVal;
    const tagIndexToRemove = filterSelectedValues.findIndex(
      (tag: Tag) => tagID === tag.id
    );
    filterSelectedValues.splice(tagIndexToRemove, 1);
    this.filtersCallBack[0].processFiltersCallback();
  }
}
